<div class="container request-access-form">
  <div class="row">
    <h5 class="header-tab mt-3" *ngIf="pageTitle">
      {{ pageTitle }}
    </h5>
    <div class="form-row">
      <div class="col-sm-8">
        <p>
          {{ pageDescription }}
        </p>
      </div>
    </div>

    <div>
      <form
        [formGroup]="frmGroup"
        id="request-access"
        (ngSubmit)="saveSupportRequest($event, form)"
        #form="ngForm"
        [action]="requestAccessUrl?.fieldInfo.fieldValue"
        method="POST"
      >
        <input
          type="hidden"
          [name]="oid?.fieldInfo.fieldName"
          [value]="oid?.fieldInfo.fieldValue"
        />
        <input
          type="hidden"
          [name]="requestAccessUrl?.fieldInfo.fieldName"
          [value]="requestAccessReturnUrl"
        />
        <input
          type="hidden"
          [name]="lead_source?.fieldInfo.fieldName"
          [value]="lead_source?.fieldInfo.fieldValue"
        />
        <input
          type="hidden"
          [name]="debug?.fieldInfo.fieldName"
          [value]="debug?.fieldInfo.fieldValue"
        />
        <input
          type="hidden"
          [name]="debugEmail?.fieldInfo.fieldName"
          [value]="debugEmail?.fieldInfo.fieldValue"
        />
        <input
          type="hidden"
          [id]="first_name?.fieldInfo.fieldName"
          [name]="first_name?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="last_name?.fieldInfo.fieldName"
          [name]="last_name?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="company?.fieldInfo.fieldName"
          [name]="company?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="office_address?.fieldInfo.fieldName"
          [name]="office_address?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="city?.fieldInfo.fieldName"
          [name]="city?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="RequestState?.fieldInfo.fieldName"
          [name]="RequestState?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="zip?.fieldInfo.fieldName"
          [name]="zip?.fieldInfo.fieldID"
        />
       <input
          type="hidden"
          [id]="phone?.fieldInfo.fieldName"
          [name]="phone?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="email?.fieldInfo.fieldName"
          [name]="email?.fieldInfo.fieldID"
        />
        <input
          type="hidden"
          [id]="access_request_origination?.fieldInfo.fieldName"
          [name]="access_request_origination?.fieldInfo.fieldID"
          [value]= accessRequestOriginate
        />
<!--         <input
          type="hidden"
          [id]="business_agreement?.fieldInfo.fieldName"
          [name]="business_agreement?.fieldInfo.fieldID"
        />        
 --> 
 <div
 class="col-sm-12 support-form"
 *ngFor="let items of supportRequestField"
>
 <div class="col-sm-8">
   <hcc-input-generator
     [frmGroup]="frmGroup"
     [fieldInfo]="items?.fieldInfo"
     [control]="items?.fieldInfo?.fieldName"
     [InputConfig]="items?.config"
   ></hcc-input-generator>
 </div>
</div>        
 <div class="form-row">
  <div
    class="col-sm-12 support-form"
    *ngFor="let items of phoneRequestField"
  >
    <div class="col-sm-10 tab">
      <hcc-input-generator
        [frmGroup]="frmGroup"
        [fieldInfo]="items?.fieldInfo"
        [control]="items?.fieldInfo?.fieldName"
        [InputConfig]="items?.config"
      ></hcc-input-generator>
    </div>
  </div>
  <div
    class="col-sm-12 support-form"
    *ngFor="let items of emailRequestField"
  >
    <div class="col-sm-10 tab">
      <hcc-input-generator
        [frmGroup]="frmGroup"
        [fieldInfo]="items?.fieldInfo"
        [control]="items?.fieldInfo?.fieldName"
        [InputConfig]="items?.config"
      ></hcc-input-generator>
    </div>
  </div>
</div>
<input
type="hidden"
[id]="business_agreement?.fieldInfo.fieldName"
[name]="business_agreement?.fieldInfo.fieldID"
/>        
        <div class="col-sm-14">
          <label class="col-sm-11">
            {{ requestFormLabel.supportRequestLabel }}
          </label>
          <div class="form-row col-sm-8 p-l-0" *ngIf="checkboxFlag">
            <div
              class="productField"
              *ngFor="let items of supportRequestProduct"
            >
              <hcc-input-generator
                [frmGroup]="frmGroup"
                [fieldInfo]="items?.fieldInfo"
                [control]="items?.fieldInfo?.fieldName"
                [InputConfig]="items?.config"
              ></hcc-input-generator>
            </div>
          </div>
        </div>
        <br/>
        <div class="col-sm-14">
          <label class="col-sm-11">
            {{ requestFormLabel.premiumProductLabel
            }}<span class="required-star">*</span>
          </label>
          <div class="form-row col-sm-7 p-all-0">
            <div *ngFor="let items of premiumProduct">
              <hcc-input-generator
                [frmGroup]="frmGroup"
                [fieldInfo]="items?.fieldInfo"
                [control]="items?.fieldInfo?.fieldName"
                [InputConfig]="items?.config"
              ></hcc-input-generator>
            </div>
            <div
              class="alert alert-warning"
              *ngIf="hasFormBeenSubmitted && !radioSelected"
            >
              Premium is required
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="button-row support-btn" style="float:left">
            <button type="submit" class="btn btn-primary">
              {{ buttonLabel }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- testing -->